import React from 'react';
import { Heading } from 'components/core';
import { Props as HeadingProps } from 'components/core/Typography/components/Heading/Heading';

const LEVELS = {
  1: { type: 'h4', component: 'h2' },
  2: { type: 'h5', component: 'h3' },
  3: { type: 'h6', component: 'h4' },
} as const;

export type ModalHeadingLevel = keyof typeof LEVELS;

export type ModalHeadingProps = {
  level?: ModalHeadingLevel;
} & Omit<HeadingProps, 'type' | 'component'>;

export const ModalHeading = ({ level = 2, ...props }: ModalHeadingProps) => {
  const { type, component } = LEVELS[level];

  return <Heading type={type} component={component} {...props} />;
};
